define('shoptheme/components/layout/trigger',[
	"jquery",
	"lodash",
	"cartware/components/_base"
], function(
	$,
	_,
	Component
) {
	return Component.create({

		config:		null,

		constructor: function() {
			// Create config
			this.config = {
				'.b_product-item': {
					'trigger': '.trigger__product-overlay',
					'target': '.b_product-item__overlay',
					'event': 'click'
				}
			};
		},

		$init: function() {
			var $body = $(document.body);
			_.forEach(this.config, function(data, selector) {
				$body.on(data.event, selector + " " + data.trigger, function(e) {
					var trigger = $(e.currentTarget),
						target = trigger.parents(selector).find(data.target);

					e.preventDefault();

					if (trigger.hasClass('active')) {
						trigger.removeClass('active');
						target.fadeOut(300);
					} else {
						trigger.addClass('active');
						target.fadeIn(300);
					}
				});
			});
		}

	});
});
